import style from './style.css';
import Button from 'preact-material-components/Button';

const CheckEligibleBtn = (props) => {
  const { btnTxt, btnClick } = props;

  return (
    <Button className={style.checkEligibleBtn} onClick={() => btnClick()}>
      {btnTxt}
    </Button>
  );
};

export default CheckEligibleBtn;



// WEBPACK FOOTER //
// ./routes/program-landing-page/components/userStatus/checkEligibleBtn.js